<template>
   <div id="dashboard_wrapper">
      <div class="card-body">
         <div class="alert alert-success" role="alert" v-if="loading">
            {{ $t("account-page-notif-control.image_in_email_notice.success_msg") }}
         </div>
         <h4 class="card-title">
            {{ $t("account-page-notif-control.image_in_email_notice.title") }}
         </h4>
         <br />

         <p> {{ $t("account-page-notif-control.image_in_email_notice.first_paragraph") }} </p>
         <hr />

         <!-- display image radios -->
         <div class="form-group row ml-2">
            <div class="form-check form-check-inline">
               <input v-model="imageInEmailNotice.value.visibility" class="form-check-input" type="radio"
                  name="imageInEmailNoticeOptions" id="displayDefaultImageRadio" :value="true" />
               <label class="form-check-label ml-4" for="displayDefaultImageRadio">
                  {{ $t("account-page-notif-control.image_in_email_notice.display_default_image_label") }}
               </label>
            </div>
         </div>

         <div class="form-group row ml-2">
            <div class="form-check form-check-inline">
               <input v-model="imageInEmailNotice.value.visibility" class="form-check-input" type="radio"
                  name="imageInEmailNoticeOptions" id="hideImageRadio" :value="false" />
               <label class="form-check-label ml-4" for="hideImageRadio">
                  {{ $t("account-page-notif-control.image_in_email_notice.hide_image_label") }}
               </label>
            </div>
         </div>

         <!-- form button -->
         <br />
         <div class="row">
            <div class="col-lg-12" align="center">
               <button @click.prevent="
                  $router.push({
                     name: 'checkin-facility-dashboard-notif-control',
                  })" class="btn btn-danger ml-3">
                  {{ $t("account-page-notif-control.image_in_email_notice.back_btn") }}
               </button>

               <button @click="$bvModal.show('modal-confirmation')" type="button" class="btn btn-primary ml-3">
                  {{ $t("account-page-notif-control.image_in_email_notice.confirm_btn") }}
               </button>
            </div>
         </div>

      </div> <!-- end card body -->

      <confirmation-modal-component @click-handler="submit" />
   </div>
</template>
<script>
import ConfirmationModalComponent from "./../../components/confirmation-modal.component";

export default {
   components: {
      ConfirmationModalComponent
   },
   data() {
      return {
         loading: false,
         facility: {},
         imageInEmailNotice: {
            facility_id: 0,
            name: 'image_in_email_notice',
            value: {
               visibility: true // DEFAULT - ON: Show the default image in emails.
            }
         },
      }
   },

   async mounted() {
      this.facility = window._app_facility
      this.initImageInEmailNotice();
   },

   methods: {
      async initImageInEmailNotice() {
         this.imageInEmailNotice.facility_id = this.facility.id;

         const res = await this.$lionheart
            .get('/v2/facility-settings', {
               params: {
                  facility_id: this.facility.id,
                  name: this.imageInEmailNotice.name,
                  paginate: 0
               }
            })
            .then(r => r.data.data)
            .catch(e => this.catcher(e));

         if (!res || res.length == 0) return;

         const visibility = res[0].value?.visibility ?? null;
         if (visibility != null) {
            this.imageInEmailNotice.value.visibility = visibility;
         }
      },
      async submit() {
         this.loading = true;
         const data = {
            facility_id: this.facility.id,
            name: this.imageInEmailNotice.name,
            value: { visibility: this.imageInEmailNotice.value.visibility }
         }

         await this.$lionheart.post('/v2/facility-settings', { ...data })
            .then(r => r.data.data)
            .catch(e => this.catcher(e))

         location.href = "#dashboard_wrapper"
         setTimeout(() => {
            this.loading = false
         }, 3000);
      },
   }
}
</script>
